/**
 * /tenants/$slug/applications — thin route shim.
 *
 * All domain logic lives in features/applications/. This file is
 * now structurally identical to every other feature route — the
 * old inline 300-line page has been replaced with the canonical
 * shape.
 */

import { createFileRoute } from "@tanstack/react-router";
import {
  applicationsListSearchSchema,
  type ApplicationsListSearch,
} from "@/features/applications/schemas";
import { fetchApplicationsList } from "@/features/applications/queries";
import { queryKeys } from "@/lib/query-keys";
import { ApplicationsListPage } from "@/features/applications/pages/applications-list-page";

export const Route = createFileRoute("/_authed/tenants/$slug/applications/")({
  validateSearch: (raw: Record<string, unknown>): ApplicationsListSearch =>
    applicationsListSearchSchema.parse(raw),
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.applications.list(context.tenant.id, deps.search),
      queryFn: () => fetchApplicationsList(context.tenant.id, deps.search),
    }),
  component: ApplicationsListPage,
});
